<a
  [routerLink]="[type(), cooperation().id]"
  class="flex w-full cursor-pointer items-center justify-between gap-2 rounded border-b border-proffeo-overlay-subtle p-2 transition-default hover:bg-proffeo-surface-muted max-md:flex-wrap"
>
  <div class="flex min-w-0 flex-1 items-center gap-2">
    <mat-icon
      fontIcon="business"
      class="max-md:hidden icon-md"
    />
    <p
      [title]="partnerName()"
      class="truncate text-proffeo-text max-md:text-xs"
    >
      {{ partnerName() }}
    </p>
    <span class="shrink-0 rounded px-1.5 py-0.5 text-xs max-md:text-[10px]">
      {{ statusLabel() | translate }}
    </span>
  </div>
  @if (type() === 'incoming' && cooperation().status === CooperationStatusEnum.Pending) {
    <div
      (click)="preventNavigation($event)"
      class="flex shrink-0 items-center gap-1 max-md:hidden"
    >
      <proffeo-ui-button
        (clicked)="preventNavigation($event); accept()"
        [text]="'cooperations.accept' | translate"
        variant="accent"
        class="!py-1 !text-sm"
      ></proffeo-ui-button>
      <proffeo-ui-button
        (clicked)="preventNavigation($event); reject()"
        [text]="'cooperations.reject' | translate"
        variant="secondary"
        class="!py-1 !text-sm"
      ></proffeo-ui-button>
    </div>
    <div
      (click)="preventNavigation($event)"
      [matMenuTriggerFor]="actionsMenu"
      class="max-md:flex hidden"
    >
      <mat-icon
        fontIcon="more_vert"
        class="cursor-pointer"
      />
    </div>
  }
  @if (cooperation().status === CooperationStatusEnum.Accepted) {
    <div
      (click)="preventNavigation($event)"
      class="flex shrink-0 items-center gap-1 max-md:hidden"
    >
      <proffeo-ui-button
        (clicked)="preventNavigation($event); openDeactivateConfirmationDialog()"
        [text]="'cooperations.deactivate' | translate"
        variant="secondary"
        class="!py-1 !text-sm"
      ></proffeo-ui-button>
    </div>
    <div
      (click)="preventNavigation($event)"
      [matMenuTriggerFor]="acceptedActionsMenu"
      class="max-md:flex hidden"
    >
      <mat-icon
        fontIcon="more_vert"
        class="cursor-pointer"
      />
    </div>
  }
</a>

<mat-menu #actionsMenu="matMenu">
  <div class="flex flex-col">
    <proffeo-ui-button
      (clicked)="accept()"
      variant="ghost"
      fontIcon="check"
      text="cooperations.accept"
      class="w-full justify-start rounded-none"
    />
    <proffeo-ui-button
      (clicked)="reject()"
      variant="ghost"
      fontIcon="close"
      text="cooperations.reject"
      class="w-full justify-start rounded-none"
    />
  </div>
</mat-menu>

<mat-menu #acceptedActionsMenu="matMenu">
  <div class="flex flex-col">
    <proffeo-ui-button
      (clicked)="openDeactivateConfirmationDialog()"
      variant="ghost"
      fontIcon="block"
      text="cooperations.deactivate"
      class="w-full justify-start rounded-none"
    />
  </div>
</mat-menu>
